import { formationModuleHref } from "@/formation/karateFormationUi.js";

/** @type {Record<string, [string, string]>} trackId, stepId */
const FORMATION_HELP_LINKS = {
  "admin-accounts": ["admin", "admin-04-accounts"],
  "admin-students": ["admin", "admin-02-members"],
  "admin-instructors": ["admin", "admin-03-instructors"],
  "admin-attendance": ["admin", "admin-07-attendance"],
  "admin-progression": ["admin", "admin-08-grades"],
  "sensei-dashboard": ["sensei", "sensei-01-dashboard"],
};

/**
 * @param {Record<string, object>} registry
 * @param {'fr'|'en'} locale
 */
export function attachFormationHelpLinks(registry, locale = "fr") {
  const label =
    locale === "en" ? "Open related training module" : "Ouvrir le module Formation correspondant";
  const next = { ...registry };
  for (const [screenId, [trackId, stepId]] of Object.entries(FORMATION_HELP_LINKS)) {
    const topic = next[screenId];
    if (!topic) continue;
    next[screenId] = {
      ...topic,
      formationModule: { trackId, stepId, href: formationModuleHref(trackId, stepId) },
      actions: topic.actions?.includes(label) ? topic.actions : [...(topic.actions || []), label],
    };
  }
  return next;
}
